export const GET_CURRENT_WITHOUT_RELATIONSHIPS_USER = "GET_CURRENT_WITHOUT_RELATIONSHIPS_USER";
export const GET_CURRENT_WITHOUT_RELATIONSHIPS_USER_SUCCESS = "GET_CURRENT_WITHOUT_RELATIONSHIPS_USER_SUCCESS";
export const GET_CURRENT_WITHOUT_RELATIONSHIPS_USER_ERROR = "GET_CURRENT_WITHOUT_RELATIONSHIPS_USER_ERROR";
export const GET_CURRENT_USER_JWT = "GET_CURRENT_USER_JWT";
export const GET_CURRENT_USER_JWT_SUCCESS = "GET_CURRENT_USER_JWT_SUCCESS";
export const GET_CURRENT_USER_JWT_ERROR = "GET_CURRENT_USER_JWT_ERROR";
